//去重复
import comm from "./comm";

Date.prototype.format = function (fmt) { //author: meizz  
	fmt = fmt || "yyyy-MM-dd hh:mm:ss";
	var o = {
		"M+": this.getMonth() + 1,                 //月份   
		"d+": this.getDate(),                    //日   
		"h+": this.getHours(),                   //小时   
		"m+": this.getMinutes(),                 //分   
		"s+": this.getSeconds(),                 //秒   
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度   
		"S": this.getMilliseconds()             //毫秒   
	};
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}

String.prototype.toJSON = function () {
	const reg = /^{.*?}$/;
	if (!this || !reg.test(this)) {
		return null
	} else {
		return JSON.parse(this);
	}
}

Array.prototype.unique = function () {
	var data = this || [];
	var a = {}; //声明一个对象，javascript的对象可以当哈希表用
	for (var i = 0; i < data.length; i++) {
		a[data[i]] = true;  //设置标记，把数组的值当下标，这样就可以去掉重复的值
	}
	data.length = 0;

	for (var i in a) { //遍历对象，把已标记的还原成数组
		this[data.length] = i;
	}
	return data;
}

//是否存在
Array.prototype.contains = function ($value) {
	for (var $i = 0; $i < this.length; $i++) {
		var $element = this[$i];
		if ($element == $value)
			return true;
	}

	return false;
}
/**
 * 删除之后的元素
 * @param $value
 * @returns {Boolean}
 */
Array.prototype.removeIndexLast = function ($num) {
	for (var $i = 0; $i < this.length; $i++) {
		var $element = this[$i];
		if ($i > $num) this.remove($element);
	}
}

/**
 * 将指定元素 之后的 元素 替换为一个元素
 * @param $num
 * @param item
 */
Array.prototype.replaceIndexLast = function ($num, item) {
	this.splice($num, this.length - 1, $.extend(true, {}, item));
}

/**
 * 删除指定下标之后的所有元素
 * @param $num
 */
Array.prototype.removeIndexLast2 = function ($num) {
	this.splice($num, this.length - 1);
}

Array.prototype.indexOf = function ($value) {
	for (var $i = 0; $i < this.length; $i++) {
		var $element = this[$i];
		if ($element == $value)
			return $i;
	}

	return -1;
}

Array.prototype.remove = function (dx) {
	this.splice(this.indexOf(dx), 1);
}

//清空数组
Array.prototype.clear = function () {
	this.length = 0;
}

//添加所有
Array.prototype.addAll = function ($array) {
	if ($array == null || $array.length == 0)
		return;

	for (var $i = 0; $i < $array.length; $i++) {
		if (!this.contains($array[$i])) {
			this.push($array[$i]);
		}
	}
}


var jsonUtils = {
	accountCut(value, type) {
		let _value;
		if (typeof value !== "string") {
			_value = String(value);
		} else {
			_value = value;
			if (type === "email") {
				const regEmail = /(\S{2})(\S)*@/;
				return _value.replace(regEmail, (a, b) => {
					return `${b}*****@`
				})
			} else if (type === "phone") {
				const regPhone = /(\d{2})(\d)*(\d{2})/;
				return _value.replace(regPhone, (a, b, c, d) => {
					return `${b}*****${d}`
				})
			} else {
				return value;
			}
		}
	},
	randomLetter(num) {
		const Num = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "g", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "G", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
		return [...new Array(num)].reduce(pre => { return pre + Num[Math.round(Math.random() * Num.length)] }, '')
	},
	replaceAll(str, replace_str) {
		return str.split(replace_str).join('')
	},
	"getSumByCol": function (rows, colname, condition, value, initval) {

		var row = null, sumval = 0, oneval = 0;

		if (COMMON.isEmpty(initval)) {
			sumval = 0;
		} else {
			sumval = initval;
		}
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (row[condition] == value) {
					if (row[colname] == null || row[colname] == '') {
						oneval = 0;
					} else {
						oneval = row[colname];
					}
					sumval = parseFloat(sumval) + parseFloat(oneval);
				}
			}
		}
		return sumval;
	},
	checkImageSize(file, filePic, width1, height1, callback) {
		//读取图片数据
		let reader = new FileReader();
		reader.onload = function (e) {
			let data = e.target.result;
			//加载图片获取图片真实宽度和高度
			let image = new Image();
			image.onload = function () {
				let width = image.width;
				let height = image.height;
				if (width >= width1 && height >= height1) {
					callback({ state: true })
					return true;
				} else {
					file.value = "";
					callback({ state: false, width: width1, height: height1 })
					return false;
				}
			};
			image.src = data;
		};
		reader.readAsDataURL(filePic);
	},

	/**
	 * 检测是否存在指定字符 替换成相应 字符
	 * @param map
	 * @param str
	 * @param rep_str
	 */
	"replaceMapVal": function (map, str, rep_str) {
		for (var key in map) {
			if (String(map[key]).indexOf(str) != -1) {
				map[key] = map[key].replaceAll(str, rep_str);
			}
		}
	},
	/**
	 * 查询集合中指定列 指定值 返回单条记录
	 */
	"findRowByColAndVal": function (rows, colname, value) {
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				let row = rows[i];
				if (row[colname] == value) {
					return row;
				}
			}
		}
		return null;
	},
	"sumRowsByCol": function (rows, colname) {
		var sumval = 0, oneval = 0;
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				oneval = row[colname];
				if (oneval == null || oneval == '') {
					oneval = 0;
				}
				sumval = Number(Decimal.add(sumval, oneval).valueOf());
			}
		}
		return sumval;
	},
	/**
	 * 查询指定列 转换为数组
	 * @param rows
	 * @param colname
	 * @returns {Array}
	 */
	"findArrayByCol": function (rows, colname) {
		var array = [];
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				let row = rows[i];
				if (row[colname] != null) {
					array.push(row[colname]);
				}
			}
		}
		return array;
	},
	/**
	 * 查询集合中 指定列 等于 某值 返回指定列 数组
	 * @param rows 集合
	 * @param colname 查询某列
	 * @param array_column 得到某列
	 * @param val 判断值
	 * @returns {Array}
	 */
	"findArrayByColVal": function (rows, colname, array_column, val) {
		var array = [];
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (row[colname] != null) {
					if (row[colname] == val) {
						array.push(row[array_column]);
					}
				}
			}
		}
		return array;
	},
	/**
	 * 从集合中查询指定字段用指定分隔符分隔返回字符串
	 * @param rows 集合
	 * @param colname 字段名
	 * @param split 分隔符
	 * @returns
	 */
	"getStringByCol": function (rows, colname, split) {
		var array = [];
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (row[colname] != null) {
					array.push(row[colname]);
				}
			}
		}
		return array.join(split);
	},
	"findMapByCol": function (rows, colname) {
		var array = {};
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (row[colname] != null) {
					array[row[colname]] = row;
				}
			}
		}
		return array;
	},
	"isExitsVal": function (list, name) {
		var isState = false;
		list.filter(function (item) {
			if (String(item).indexOf(String(name).toLowerCase()) >= 0) {
				isState = true;
				return false;
			}
		});

		return isState;
	},
	"getListExitsVal": function (list, name) {
		let array = [], arrayList = [], res = {};
		list.filter(function (item) {
			if (String(item).indexOf(String(name).toLowerCase()) >= 0) {
				array.push(item);
			} else {
				arrayList.push(item);
			}
		});
		return { inList: array, notInList: arrayList };
	},
	"isNumber": function (val) {
		// isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除
		if (val === "" || val == null) {
			return false;
		}
		if (!isNaN(val)) {
			return true;
		} else {
			return false;
		}
	},
	"toNumber": function (val) {
		if (val === "" || val == null) {
			return 0;
		} else {
			return Number(val)
		}
	},
	"isArray": function (array) {
		if (array instanceof Array) {
			return true;
		}
		return false
	},
	RandomNum: function (Min, Max) {
		var Range = Max - Min;
		var Rand = Math.random();
		var num = Min + Math.round(Rand * Range);
		return num;
	},
	/**
	 * 验证对象是否为空对象
	 * @parms obj 验证对象
	 **/
	"isEmptyObj": function (obj) {
		if (obj == null) {
			return true;
		}
		if (JSON.stringify(obj) == '{}') {
			return true;
		} else {
			return false;
		}
	},
	"isExitsKey": function (obj, key) {
		if (obj == null) {
			return false;
		}

		for (var a in obj) {
			if (a == key) {
				return true;
			}
		}

		return false;
	},
	/**
	 * 清空对象
	 * @param obj
	 */
	'clearObject': function (obj) {
		for (key in obj) {
			obj[key] = '';
		}
	},
	/**
	 * 简单查询条件
	 * @param columns
	 * @returns {String}
	 */
	"search_option": function (columns) {
		var cxtj = "";
		var items, item = '', col, headers_str = "", columns_str = "";
		for (var i = 0, n = columns.length; i < n; i++) {
			col = columns[i];
			if (col.isselect == null || col.isselect == true) {
				col.isselect = true;
			} else {
				col.isselect = false;
			}
			if (!COMMON.isEmpty(col.field) && col.title != "操作" && col.isselect && (col.visible == null || col.visible)) {
				if (item == '') {
					item = item + '\'' + col.field + '\':\'' + col.title + '\'';
					headers_str += col.title;
					columns_str += col.field;
					cxtj += "(" + col.field + " like binary 'aYdF1u88888'bYdF1";
				} else {
					item = item + ',\'' + col.field + '\':\'' + col.title + '\'';
					headers_str += ',' + col.title;
					columns_str += ',' + col.field;
					cxtj += " or " + col.field + " like binary 'aYdF1u88888'bYdF1";
				}
			}
			if (i == n - 1) {
				cxtj += ")";
			}
		}
		return cxtj;
	},
	"option_items": function (columns) {
		var cxtj = "";
		var items, item = '', col, headers_str = "", columns_str = "";
		for (var i = 0, n = columns.length; i < n; i++) {
			col = columns[i];
			if (col.isselect == null || col.isselect == true) {
				col.isselect = true;
			} else {
				col.isselect = false;
			}
			if (!COMMON.isEmpty(col.field) && col.title != "操作" && col.isselect && (col.visible == null || col.visible)) {
				if (item == '') {
					item = item + '\'' + col.field + '\':\'' + col.title + '\'';
				} else {
					item = item + ',\'' + col.field + '\':\'' + col.title + '\'';
				}
			}
		}

		if (!COMMON.isEmpty(item)) {
			item = '{' + item + '}';
			items = eval('(' + item + ')');
		}

		return items;
	},
	//创建 select options
	"createSelectOptions": function (column_name, items, mr) {
		var col_items = "", itemstr = "";
		col_items = '' +
			'<select class="select1" id="divTextEdit' + column_name + 'index" style="width:100%" \'>';
		if (!COMMON.isEmpty(mr)) {
			col_items += '<option value=""></option>';
		}

		for (var key in items) {
			itemstr = '<option value="' + key + '">' + items[key] + '</option>';
			col_items += itemstr;
		}

		col_items += '</select>';


		/*table-col-selectcreateSelectOptions*/

		return col_items;
	},
	'findCountItemByList': function (list, name, val) {
		var i = 0;
		for (var item in list) {
			if (list[item][name] === val) {
				i++
			}
		}
		return i;
	},
	'deleteItemByList': function (list, name, val) {
		var delteall = [];
		list = list.filter(function (item) {
			if (item[name] === val) {
				return false;
			} else {
				return true;
			}
		});
		return list;
	},
	/**
	 * 查询集合中指定列 指定值 返回集合
	 */
	findArrayByColAndVal: function (rows, colname, value) {
		var resArray = []
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				let row = rows[i];
				if (row[colname] == value) {
					resArray.push(row);
				}
			}
		}
		return resArray;
	},
	/**
	 * 得到指定字段
	 * @param rows
	 * @param colname
	 * @param value
	 * @param n
	 * @returns {Array}
	 */
	findBeforeArrayByColAndVal: function (rows, colname, value, number) {
		var resArray = []
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (stringUtils.left(String(row[colname]), number) == value) {
					resArray.push(row[colname]);
				}
			}
		}
		return resArray;
	},
	/**
	 * 验证选中数据是否重复
	 * @param parms_ 替换值
	 * @param row 选中数据当前行
	 * @param dataitem 明细数据行
	 * @param verification_ 验证字段
	 * @param mxObject 明细数据
	 * @returns {Boolean}
	 */
	checkDataRepetition: function (parms_, row, dataitem, verification_, mxObject) {
		var map = parms_;
		if (!COMMON.isEmpty(map)) {
			for (var key in map) {
				val_key = map[key];
				if (COMMON.isEmpty(row[val_key])) {
					//var a = row[val_key];
					if (val_key.indexOf('_val') >= 0) {
						val = val_key.replace('_val', '');
					} else {
						//val = val_key;
						val = ''
					}
				} else {
					val = row[val_key];
				}
				dataitem[key] = val;
			}
		}
		//验证数据重复
		var ispd = true, c, flagalert = false;
		if (!COMMON.isEmpty(verification_)) {
			c = verification_.split(';');
			for (var m = 0; m < mxObject.length; m++) {
				var str1 = "";
				var str2 = "";
				var curr_row = mxObject[m];
				for (var n = 0; n < c.length; n++) {
					str1 += eval('curr_row.' + c[n]) + ";";
					str2 += eval('dataitem.' + c[n]) + ";";
				}
				if (str1 != "" && str2 != "" && str1 == str2) {
					ispd = false;
					flagalert = true;
				}
			}
		}

		return ispd;
	},

	/**
	 * 设置list 属性 为 val
	 * @param list
	 * @param key
	 * @param val
	 * @returns
	 */
	'setListAttrByVal': function (list, key, val) {
		for (var i = 0, n = list.length; i < n; i++) {
			list[i][key] = val;
		}
		return list;
	},
	imageUrl: function (value, defaultImg, width, height) {
		if (!value || value === "") {
			if (defaultImg) {
				return defaultImg;
			} else {
				return "/static/sample/avatar.png";
			}
		}
		//debugger
		if (value.indexOf("http://") > -1 || value.indexOf("https://") > -1) {
			if (value.indexOf('manamana') !== -1) {
				if (value.includes("?vframe")) {
					const url = value.split("?")[0];
					const time = value.split("?vframe/jpg/offset/")[1].split('/')[0];
					return `${url}?vframe/jpg/offset/${time}|imageView2/1/w/${width}/h/${height}`
				  }
				if (width && height) {
					if (!value.includes("/w/")) {
						if (value.indexOf('imageMogr2/') > -1) {
							return `${value.split('?')[0]}?imageView2/1/w/${width}/h/${height}`;
						} else {
							if (value.indexOf("?") > -1) {
								return `${value}&imageView2/1/w/${width}/h/${height}`;
							} else {
								return `${value}?imageView2/1/w/${width}/h/${height}`;
							}
						}
					} else {
						let end = value.indexOf("/w/");
						let str = value.substr(0, end) + `/w/${width}/h/${height}`;
						if (str.includes('video.manamana.net') && str.includes('image.manamana.net')) {
							return str.replace('https://image.manamana.net/', '')
						} else {
							return str
						}
					}
				} else if (width || height && value.includes("?vframe")) {
					return height ? `${value.split("?")[0]}?vframe/jpg/offset/${value.split("?vframe/jpg/offset/")[1].split('/')[0]}/h/${height}` : `${value.split("?")[0]}?vframe/jpg/offset/${value.split("?vframe/jpg/offset/")[1].split('/')[0]}/w/${width}`;
				}
				return value;
			} else {
				return value;
			}
		} else if (value.indexOf("/uploads/") > -1) {
			let url = `https://www.manamana.net/${value}`;
			if (width && height) {
				if (url.indexOf("?") > -1) {
					return `${url}&imageView2/1/w/${width}/h/${height}`;
				} else {
					return `${url}?imageView2/1/w/${width}/h/${height}`;
				}
				return url;
			} else {
				return url;
			}
		} else {
			let url = `https://image.manamana.net/${value}`;
			if (width && height) {
				if (url.indexOf("?") > -1) {
					return `${url}&imageView2/1/w/${width}/h/${height}`;
				} else {
					return `${url}?imageView2/1/w/${width}/h/${height}`;
				}
				return url;
			} else {
				return url;
			}
		}
	},
	/**
	 * vue中设置每一行列的值
	 * @param obj
	 * @param list
	 * @param key
	 * @param val
	 * @param exclude
	 * @returns
	 */
	'$vuesetListAttrByVal': function (obj, list, key, val, exclude) {
		var row = {};
		for (var i = 0, n = list.length; i < n; i++) {

			if (',' + exclude + ','.indexOf(',' + i + ',') == -1) {
				row = list[i];
				row[key] = val;
				obj.$set(list, i, row);
			}
		}
		return list;
	},
	'$vuesetListAllAttrByVal': function (obj, list, key, val) {
		var row = {};
		for (var i = 0, n = list.length; i < n; i++) {
			row = list[i];
			row[key] = val;
			obj.$set(list, i, row);
		}
		return list;
	},
	/**
	 * 设置指定集合 中符合条件 的列设置值
	 * @param obj
	 * @param list
	 * @param colname
	 * @param val1
	 * @param key
	 * @param val
	 * @returns
	 */
	'$vuesetListAttr2ByVal': function (obj, list, colname, value, key, val) {
		var resList = [];
		var row = {};
		for (var i = 0, n = list.length; i < n; i++) {
			row = list[i];
			if (row[colname] == value) {
				row[key] = val;
				obj.$set(list, i, row);
				resList.push(row)
			}
		}
		return resList;
	},
	//将base64转换为blob
	dataURLtoBlob(dataurl) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], { type: mime });
	},
	//将blob转换为file
	blobToFile(theBlob, fileName) {
		theBlob.lastModifiedDate = new Date();
		theBlob.name = fileName;
		return theBlob;
	},
	base64ToFile(dataurl, fileName) {
		let blob = this.dataURLtoBlob(dataurl);
		return new File([blob], fileName)
	},
	/**
	 * 获取对象在数组中的位置
	 * @param arr
	 * @param item
	 * @returns
	 */
	indexOf: function (arr, item) {
		return arr.indexOf(item);
	},
	/**
	 * 通过key和值返回 记录位置
	 * @param arr
	 * @param item
	 * @returns
	 */
	indexOfByColAndVal: function (arr, colname, value) {
		var row = {};
		for (var i = 0, n = arr.length; i < n; i++) {
			row = arr[i];
			if (row[colname] == value) {
				return i;
			}
		}
		return -1;
	},
	/**
	 * 移除包含 指定 列 内容 的数据
	 * @param arr
	 * @param colname
	 * @param value
	 */
	removeListByColAndVal: function (arr, colname, value) {

		var rows = [];
		for (var i = 0, n = arr.length; i < n; i++) {
			row = arr[i];
			if (value.indexOf(',' + row[colname] + ',') >= 0 || COMMON.isEmpty(row[colname])) {
				rows.push(row);
			}
		}

		if (rows != null) {
			this.removeAll(arr, rows);
		}
	},
	removeItem: function (arr, item) {

		if (typeof (item) != 'number') {
			var index = this.indexOf(arr, item);
			arr.splice(index, 1)
		} else {
			arr.splice(item, 1)
		}

	},
	/**
	 * 删除数组中指定元素
	 * @param sourceArr
	 * @param removeArr
	 */
	removeAll: function (sourceArr, removeArr) {
		if (COMMON.isEmpty(sourceArr) || COMMON.isEmpty(removeArr)) {
			return;
		}
		for (var i = 0, n = removeArr.length; i < n; i++) {
			var index = this.indexOf(sourceArr, removeArr[i]);
			sourceArr.splice(index, 1)
		}
	},
	clear: function (list) {
		list = [];
	},
	/**
	 * 将 a=1,b=2,c=3 转换成 JSON 对象
	 */
	strToJson: function (str) {
		return JSON.parse('{"' + str.replace(/=/g, '":').replace(/,/g, ',"') + "}");
	},
	/**
	 * 复制指定属性到指定对象
	 * @param form
	 * @param parms
	 */
	copyObjectAttr: function (form, parms) {
		var copy_row = $.extend(true, {}, parms);
		for (var key in parms) {
			copy_row[key] = form[parms[key]];
		}
		return copy_row;
	},
	/**
	 * 比较两个对象中 相同属性 不同值
	 * @param one
	 * @param two
	 */
	compareTwoObject: function (one, two) {
		var c_key = '';
		for (var key in one) {
			if (one[key] != two[key]) {
				c_key = key;
				break;
			}
		}

		return c_key;
	},
	/**
	 * 根据公式计算值 更新数据到行
	 * @param current_row
	 * @param current_gs
	 */
	cauculateFormula: function (current_row, current_gs, isCopy) {
		//是否复制对象
		var copy_row = null;
		if (COMMON.isEmpty(isCopy)) {
			copy_row = $.extend(true, {}, current_row);
		} else {
			copy_row = current_row;
		}

		if (!COMMON.isEmpty(current_gs)) {
			var gs_array = [];
			if (current_gs.indexOf(';') > 0) {
				gs_array = current_gs.split(';')
			} else {
				gs_array.push(current_gs);
			}

			var start = -1, end = -1, key = '', val = -1;
			//获取form 表单 数据
			var form = getFrom('form');

			for (var i = 0, n = gs_array.length; i < n; i++) {
				var gs_one = gs_array[i];
				var gs_one_array = [];
				var from = '', to = '';
				if (gs_one.indexOf('=')) {
					gs_one_array = gs_one.split('=');
					from = gs_one_array[0];
					to = gs_one_array[1];
				}
				var a = 0
				while (from.indexOf('[') >= 0 && from.indexOf(']') >= 0) {
					start = from.indexOf('[') + 1;
					end = from.indexOf(']');
					key = from.substring(start, end);
					//如果获取不到 取 form 中的数据
					if (COMMON.isEmpty(copy_row[key])) {
						//取得form 中的 数据
						if (COMMON.isEmpty(form[key])) {
							val = 0;
						} else {
							val = form[key]
						}

					} else {
						val = copy_row[key];
					}

					if (jsonUtils.isNumber(val)) {
						val = new Decimal(val).valueOf();
					}

					from = from.replace('[' + key + ']', val);
					//防止死循环;跳出
					if (a++ > 20) { return; }
				}
				//计算公式所得值
				if (!COMMON.isEmpty(to)) {
					var aa_array, bb, cc;
					if (to.indexOf(',') >= 0) {
						aa_array = to.split(',');
						bb = aa_array[0];
						cc = aa_array[1];
						var v = eval(from);
						var val = eval('COMMON.toNumber(' + v + ',' + cc + ')');
						copy_row[bb] = val;
					} else {
						copy_row[to] = eval(from);
					}
				}
			}
		}

		return copy_row;
	},
	/**
	 * 设置集合中 指定列 指定值
	 * @param rows
	 * @param colname
	 * @returns {}
	 */
	"setListByCol_Val": function (rows, colname, val) {
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (!COMMON.isEmpty(row)) {
					row[colname] = val;
				}
			}
		}
	},
	/**
	 * 设置集合中 符合条件 的 列赋值 为 指定值
	 * @param arr
	 * @param colname 判断列
	 * @param value 判断值
	 * @param colname_2 设置列
	 * @param value_1 设置值
	 */
	setListByColAndVal: function (arr, colname, value, colname_2, value_2) {

		var rows = [];
		for (var i = 0, n = arr.length; i < n; i++) {
			row = arr[i];
			if (value.indexOf(',' + row[colname] + ',') >= 0 || COMMON.isEmpty(row[colname])) {
				row[colname_2] = value_2;
			}
		}

	},
	/**
	 * 将符合条件的 指定列替换成 指定属性值
	 * @param rows
	 * @param colname
	 * @param val
	 * @param colname2
	 * @param val2
	 */
	"updateListByColoneToColtwo": function (rows, colname, val, colname2, val2) {
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (!COMMON.isEmpty(row)) {
					if (COMMON.isEmpty(row[colname])) {
						row[colname2] = "readonly";
					} else {
						row[colname2] = val2;
						row['validator'] = 'validator_editOne'
					}
				}
			}
		}
		return rows;
	},
	/**
	 * 递归 为集合 指定列赋值
	 */
	'resursionSetListVal': function (rows, colname, val, children_name) {
		if (rows != null) {
			//更新叶子节点
			for (var i = 0, n = rows.length; i < n; i++) {
				var row = rows[i];
				if (!COMMON.isEmpty(row)) {
					row[colname] = val;
					var children = row[children_name]
					while (!COMMON.isEmpty(children)) {
						children = this.resursionSetListVal(children, colname, val, children_name);
					}
				}
			}
		}
		return null;
	},
	/**
	 * 将指定集合 列 值 返回 一个指定列数组
	 * @param rows
	 * @param colname
	 * @param val
	 * @param val_column
	 * @param split
	 * @returns
	 */
	"getStringByColAndVal": function (rows, colname, val, val_column, split) {
		var array = [];
		if (rows != null) {
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				if (!COMMON.isEmpty(row[colname]) && row[colname] == val) {
					array.push(row[val_column]);
				}
			}
		}
		return array.join(split);
	},
	/**
	 * 递归 为集合 指定列赋值
	 */
	'resursionArrayToList': function (rows, children_name, resRows) {
		if (rows != null) {
			var children = null;
			//更新叶子节点
			for (var i = 0, n = rows.length; i < n; i++) {
				var row = rows[i];
				if (!COMMON.isEmpty(row)) {
					resRows.push(row);
					children = row[children_name]
					while (!COMMON.isEmpty(children)) {
						children = this.resursionArrayToList(children, children_name, resRows);
					}
				}
			}
		}
		return children;
	},
	/**
	 * 获取页数
	 * @param totalRecord
	 * @param pageSize
	 * @returns {number}
	 */
	getPageCount(totalRecord, pageSize) {
		var num = totalRecord / pageSize;
		var str = String(num);
		if (str.indexOf(".") != -1) {
			num = Number(str.substr(0, str.indexOf("."))) + 1;
		}
		return num;
	},
	/**
	 * 对数组进行分页
	 * @param pageNo
	 * @param pageSize
	 * @param array
	 * @returns
	 */
	pagination: function (pageNo, pageSize, array) {
		var offset = (pageNo - 1) * pageSize;
		return (offset + pageSize >= array.length) ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
	},
	/**
	 * 数组前文搜索
	 * @param str
	 * @param container 集合 数组
	 * @returns {Array}
	 */
	searchList: function (str, container) {
		var newList = [];
		//新的列表
		var startChar = str.charAt(0);
		//开始字符
		var strLen = str.length;
		//查找符串的长度

		for (var i = 0; i < container.length; i++) {
			var obj = container[i];
			var isMatch = false;
			for (var p in obj) {
				if (typeof (obj[p]) == "function") {
					obj[p]();
				} else {
					var curItem = "";
					if (obj[p] != null) {
						curItem = obj[p];
					}
					for (var j = 0; j < curItem.length; j++) {
						if (curItem.charAt(j) == startChar) {
							if (curItem.substring(j).substring(0, strLen) == str) {
								isMatch = true;
								break;
							}
						}
					}
				}
			}
			if (isMatch) {
				newList.push(obj);
			}
		}
		return newList;
	},
	/**
	 * 初始化数组
	 * @param array
	 * @param val
	 */
	initArray: function (array, val) {
		for (var i = 0, n = array.length; i < n; i++) {
			array[i] = val;
		}
	},
	"replaceParms": function (obj, parms) {

		var str = "", a = "";

		if (obj == null) {
			return false;
		}
		var i = 0;
		while (parms.indexOf('?') != -1) {
			var end = parms.indexOf('=');
			var key = parms.substring(0, end);
			var b = 0;
			var val = obj[key];
			if (!COMMON.isEmpty(val)) {
				a = key + '=' + val
				b = parms.indexOf('&');
			} else {
				a = parms.substring(0, parms.indexOf('&'));
				b = parms.indexOf('&');
			}

			if (b == -1) {
				parms = '';
			} else {
				parms = parms.substring(b + 1, parms.length);
			}

			if (str == '') {
				str += a;
			} else {
				str += '&' + a;
			}

			if (i++ > 20) {
				break;
			}
		}
		return str;
	},
	/**
	 * 替换参数值对象
	 * @param parms
	 * @param replaceObject
	 */
	"setParmsObject": function (parms, replaceObject) {
		var copy_parms = $.extend(true, {}, parms);
		var form = {};
		if (COMMON.isEmpty(copy_parms)) {
			return {};
		}

		if (COMMON.isEmpty(replaceObject)) {
			form = getFrom('form')
		} else {
			form = replaceObject;
		}

		for (var key in parms) {
			var val_key = copy_parms[key];
			//如果不存在 取 keyval
			if (COMMON.isEmpty(form[val_key])) {
				var form_ = getFrom('form')
				if (COMMON.isEmpty(form_[val_key])) {
					copy_parms[key] = val_key;
				} else {
					copy_parms[key] = form_[val_key];
				}

			} else {
				copy_parms[key] = form[val_key];
			}
		}

		return copy_parms;
	},
	/**
	 * 将一个对象复制到另一个对象中
	 * @param parms1
	 * @param parms2
	 */
	mapPutAll: function (parms1, parms2) {
		for (var key in parms2) {
			parms1[key] = parms2[key];
		}
		return parms1;
	},
	"getUniqueDataByCol": function (rows, colnames) {
		var array = [], temp_array = [];
		if (rows != null) {
			var cols = colnames.split(',');
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i];
				var a = {};
				for (var j = 0, nj = cols.length; i < nj; j++) {
					var b = cols[j];
					a[b] = row[b];
				}

				if (this.indexOf(temp_array, a) < 0) {
					temp_array.push(a)
				}
			}
		}
		return array.join(split);
	},
	"mergeStrBycloumns_one": function (rows, columns) {

		if (rows == null) { return; }
		if (columns == null || columns == '') { return; }

		var row, res = "";
		for (var i = 0, n = rows.length; i < n; i++) {
			//列集合
			var colArray = columns.split(',')
			row = rows[i];
			//一行数据
			var str = "", a;
			for (var j = 0, jn = colArray.length; j < jn; j++) {
				if (row[colArray[j]] != null) {
					a = row[colArray[j]];
				} else {
					a = '';
				}

				if (str == "") {
					str += a;
				} else {
					str += "," + a;
				}
			}
			//返回结果
			if (res == '') {
				res += str;
			} else {
				res += ";" + str;
			}
		}
		return res;
	}, "mergeStrBycloumns_two": function (rows, columns) {

		if (rows == null) { return; }
		if (columns == null || columns == '') { return; }

		var row, res = {};
		var colArray = columns.split(',')
		row = rows[i];
		//一行数据

		for (var j = 0, jn = colArray.length; j < jn; j++) {
			key = colArray[j];
			var str = "", a;
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i]

				if (row[key] != null) {
					a = row[key];
				} else {
					a = '';
				}
				if (str == '') {
					str += a;
				} else {
					str += "," + a;
				}
			}
			res[key] = str;
		}

		return res;
	}, "mergeStrBycloumns_three": function (rows, columns, key_, checkstr) {

		if (rows == null) { return; }
		if (columns == null || columns == '') { return; }

		var row, res = {}, index_ = {};
		var colArray = columns.split(',')
		row = rows[i];
		//一行数据

		for (var j = 0, jn = colArray.length; j < jn; j++) {
			key = colArray[j];
			var str = "", a;
			for (var i = 0, n = rows.length; i < n; i++) {
				row = rows[i]

				if (row[key] != null) {
					a = row[key];
				} else {
					a = '';
				}
				var check_rows = []
				check_rows.push(row);
				if (key == key_ && !jsonUtils.exitStrBycloumns(check_rows, key_, checkstr)) {
					if (str == '') {
						str += a;
					} else {
						str += "," + a;
					}

					index_[i] = 1;

				} else if (key != key_ && index_[i] != null) {
					if (str == '') {
						str += a;
					} else {
						str += "," + a;
					}
				}

			}
			res[key] = str;
		}

		return res;
	}, "exitStrBycloumns": function (rows, columns, checkstr) {

		if (rows == null) { return; }
		if (columns == null || columns == '') { return; }

		var row, res = "", a;
		for (var i = 0, n = rows.length; i < n; i++) {
			//列集合
			var colArray = columns.split(',')
			row = rows[i];
			//一行数据
			var str = "";
			for (var j = 0, jn = colArray.length; j < jn; j++) {

				if (row[colArray[j]] != null) {
					a = row[colArray[j]];
				} else {
					a = '';
				}

				if (str == "") {
					str += a;
				} else {
					str += "," + a;
				}
			}
			//验证重复
			if (((";," + checkstr + ",;").indexOf("," + str + ",") != -1) ||
				((";," + checkstr + ",;").indexOf(";" + str + ",") != -1) ||
				((";," + checkstr + ",;").indexOf("," + str + ";") != -1)) {
				return true;
			}
		}

		return false;
	}
}

var treeUtils = {
	exists: function (rows, parent_id) {
		for (var i = 0; i < rows.length; i++) {
			if (rows[i].id == parent_id) return true;
		}
		return false;
	},
	/**
	 * 通过 id，parent_id 将列表转化为树结构，树用
	 * @param rows
	 * @returns {Array}
	 */
	convertTree: function (rows) {
		var nodes = [];
		for (var i = 0; i < rows.length; i++) {
			var row = rows[i];
			if (!this.exists(rows, row.parent_id)) {
				nodes.push(row);
			}
		}

		var toDo = [];
		for (var i = 0; i < nodes.length; i++) {
			toDo.push(nodes[i]);
		}
		while (toDo.length) {
			var node = toDo.shift();
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				if (row.parent_id == node.id) {
					if (node.children) {
						node.children.push(row);
					} else {
						node.children = [row];
					}
					toDo.push(row);
				}
			}
		}
		return nodes;
	},
	/**
	 * 通过 id，parendId 将列表转化为树结构，树据列表用
	 * @param rows
	 * @returns {Array}
	 */
	convertTreeTable: function (rows) {
		var nodes = [];
		for (var i = 0; i < rows.length; i++) {
			var row = rows[i];
			if (!exists(rows, row.parent_id)) {
				var obj = new Object();
				for (var key in rows[i]) {
					obj[key] = row[key];
				}
				nodes.push(obj);
			}
		}
		var toDo = [];
		for (var i = 0; i < nodes.length; i++) {
			toDo.push(nodes[i]);
		}
		while (toDo.length) {
			var node = toDo.shift();
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				if (row.parent_id == node.id) {
					var child = new Object();
					for (var key in rows[i]) {
						child[key] = row[key];
					}
					if (node.children) {
						node.children.push(child);
					} else {
						node.children = [child];
					}
					toDo.push(child);
				}
			}
		}
		return nodes;
	}
}
export default jsonUtils;



// WEBPACK FOOTER //
// ./src/assets/jsonutils.js